import api from './index';

let exports = {};

// 生成支付单据
exports.savePayVoucher = function (params, callback) {// 生成支付单据
    api.post('/finac/pay/voucher/save/do')
    .data(params)
    .done(callback)
    .go();
};

// 获取收款单据列表
exports.getRcvVoucherCOList = function (params, callback) {// 获取收款单据分页列表
    api.post('/finac/rcv/voucher/list/get')
    .data(params)
    .done(callback)
    .go()
};
// 生成逆向支付单据
exports.savePayVoucherRefund = function (data, callback) {// 保存逆向支付单据
    api.post('/finac/pay/voucher/refund/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 逆向支付单据审核
exports.auditPayVoucher = function (data, callback) {// 审核逆向支付单据
    api.post('/finac/pay/voucher/audit/do')
    .data(data)
    .done(callback)
    .go()
};
// 修改逆向支付单支付状态
exports.updatePayVoucherPayResult = function (data, callback) {// 修改逆向支付单支付状态
    api.post('/finac/pay/voucher/payResult/update/do')
    .data(data)
    .done(callback)
    .go();
};

// 获取支付单据
exports.getRcvVoucherCOById = function (params, callback) {// 根据id获取支付单据信息
    api.get('/finac/rcv/voucher/co/get')
    .params(params)
    .done(callback)
    .go()
};
exports.getPayVoucherByNo = function (params, callback) {// 根据单据号获取支付单据信息
    api.get('/finac/pay/voucher/get/by/no')
    .params(params)
    .done(callback)
    .go()
};

// 支付单据确认
exports.confirmRcvVoucher = function (data, callback) {// 确认买家已付款
    api.post('/finac/rcv/voucher/confirm/do')
    .data(data)
    .done(callback)
    .go()
};

// 线上退款操作
exports.refundPayUnionpayAcp = function (data, callback) {// 线上退款操作
    api.post('/finac/pay/unionpay/acp/refund/do')
    .data(data)
    .done(callback)
    .go()
};

// 根据阶段id获取阶段已支付金额和已退款金额
exports.getAmountByTrackPhaseId = function (params, callback) {// 根据阶段id获取阶段已支付金额和已退款金额
    api.get('/finac/amount/get/by/trackPhaseId')
    .params(params)
    .done(callback)
    .go()
};

// 对账管理列表0
exports.getFundTransRecList = function (params, callback) {// 获取资金往来记录列表
    api.post('/finac/fund/trans/rec/list/get')
    .data(params)
    .done(callback)
    .go()
};

// 获取佣金计费单列表
exports.getFundTransRecYjList = function (data, callback) {// 获取资金往来记录列表
    api.post('/finac/fund/trans/rec/yj/list/get')
    .data(data)
    .done(callback)
    .go()
};

// 通过对账单id获取资金往来列表信息
exports.getFundTransRecListByCheckVoucherId = function (params, callback) {// 通过对账单id获取资金往来记录列表
    api.post('/finac/fund/trans/rec/list/get/by/checkVoucherId')
    .data(params)
    .done(callback)
    .go()
};

// 保存对账单
exports.saveFundTransCheckVoucher = function (data, callback) {// 新增对账单
    api.post('/finac/fund/trans/check/voucher/save/do')
    .data(data)
    .done(callback)
    .go()
};

// 对账单列表查询
exports.getFundTransCheckVoucherList = function (data, callback) {// 获取对账单列表
    api.post('/finac/fund/trans/check/voucher/list/get')
    .data(data)
    .done(callback)
    .go()
};
// 确认对账单
exports.confirmFundTransCheckVoucher = function (data, callback) {// 对账单的确认操作
    api.post('/finac/fund/trans/check/voucher/confirm/do')
    .data(data)
    .done(callback)
    .go()
};
// 拒绝对账单
exports.rejectFundTransCheckVoucher = function (data, callback) {// 对账单的拒绝操作
    api.post('/finac/fund/trans/check/voucher/reject/do')
    .data(data)
    .done(callback)
    .go()
};
// 删除对账单
exports.deleteFundTransCheckVoucher = function (data, callback) {// 对账单的删除操作
    api.post('/finac/fund/trans/check/voucher/delete/do')
    .data(data)
    .done(callback)
    .go()
};

// 获取指定退款单据的退款操作记录列表
exports.getRefundActRecListByVoucherId = function (params, callback) {// 获取指定退款单据的退款操作记录列表
    api.get('/finac/refund/act/rec/list/get/by/voucherId')
    .params(params)
    .done(callback)
    .go()
};

exports.createInvoiveVoucher = function (data, callback) {// 登记发票
    api.post('/finac/invoive/voucher/create/do')
    .data(data)
    .done(callback)
    .go()
};

//发票信息分页列表
exports.getInvoiceVoucherList = function (params, callback) {// 获取发票信息列表
    api.post('/finac/invoice/voucher/list/get')
    .data(params)
    .done(callback)
    .go()
};

// 发票单据详细信息
exports.getInvoiceVoucherInfo = function (params, callback) {// 查看发票详情
    api.get('/finac/invoice/voucher/info/get')
    .params(params)
    .done(callback)
    .go()
};

//发票信息审核
exports.updateInvoiceVoucherAuditState = function (params, callback) {// 审核发票
    api.post('/finac/invoice/voucher/auditState/update/do')
    .data(params)
    .done(callback)
    .go()
};

//开票
exports.madeOutInvoiceVoucher = function (params, result) {// 开票
    api.post('/finac/invoice/voucher/madeOut/do')
    .data(params)
    .done(result)
    .go()
};

// 收回发票
exports.updateInvoiceVoucherForTakenBack = function (params, result) {// 收回发票
    api.post('/finac/invoice/voucher/takenback/do')
    .data(params)
    .done(result)
    .go()
};

// 作废发票
exports.invalidateInvoiceVoucher = function (params, result) {// 发票作废
    api.post('/finac/invoice/voucher/invalidate/do')
    .data(params)
    .done(result)
    .go()
};
// 删除发票
exports.deleteInvoiceVoucher = function (data, callback) {
    api.post('/finac/invoive/voucher/delete/do')
    .params(data)
    .done(callback)
    .go()
};

// 资金往来操作记录列表
exports.getFundTransActRecList = function (data, callback) {// 资金往来操作记录列表
    api.post('/finac/fund/trans/act/rec/list/get')
    .data(data)
    .done(callback)
    .go()
};

// 查询付款阶段模板项
exports.getPayPhaseTplItemListByFilter = function (data, callback) {
    api.post('/finac/pay/phase/tpl/item/get/by/filter')
    .data(data)
    .done(callback)
    .go()
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/finac.js
// module id = 49
// module chunks = 1